// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-16ccacf0]{font-size:13px;line-height:20px}.buttons[data-v-16ccacf0]{margin-top:20px;text-align:right}.buttons button[data-v-16ccacf0]{width:150px}.card[data-v-16ccacf0]{width:33%;flex-grow:1}", ""]);
// Exports
module.exports = exports;
